export default "__VITE_ASSET__f2ed7bf5__"